import { render, staticRenderFns } from "./LiveSetting.vue?vue&type=template&id=4cf77f12&scoped=true"
import script from "./LiveSetting.vue?vue&type=script&lang=js"
export * from "./LiveSetting.vue?vue&type=script&lang=js"
import style0 from "./LiveSetting.vue?vue&type=style&index=0&id=4cf77f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf77f12",
  null
  
)

export default component.exports